import * as MutationTypes from './mutationTypes';

export const setUncubesControllerReady = async ({ commit }) => {
  commit(MutationTypes.SET_UNCUBES_SERVER_READY);
};
